<div class="modal active">
  <div class="modal__container modal__container--xs">
    <div class="fields">
      <h2>Procedure Vertical Profile Options</h2>
      <div class="close" (click)="cancelVerticalProfile()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title" style="margin-top: 5px;">
                <h4>Procedure Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div style="justify-content: flex-start;margin-top: 5px;">
                  <label style="min-width: auto; width: fit-content; margin-right: 20px;" for="">Aircraft Speed</label>
                    <input id="aircraftSpeed" name="aircraftSpeed" [(ngModel)]="this.selectedProcedure.aircraftspeed" type="number" style="max-width: 100%;" required/><span>[kts]</span>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button
              type="submit"
              [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="verticalProfileCalculation(); ngForm.reset()"
              [disabled]="!ngForm.form.valid"
            >
              Ok
            </button>
            <a class="gray" href="#" type="reset" (click)="cancelVerticalProfile()" value="Cancel">Cancel</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
